<section class="dashboard">
  <div class="container-fluid">
    <ul class="nav-topo">
      <ng-container *ngFor="let item of menuModules">
        <li
          (click)="getModuleID(item.moduleID)"
          [class.active]="item.moduleID == this.moduleID"
        >
          {{ item.module }}
        </li>
      </ng-container>
    </ul>

    <div class="grid-graficos">
      <div class="item">
        <div class="DataContent">
          <h3>Total de obras por módulo</h3>
          <canvas id="grafico-ObrasModulo" height="200"></canvas>
        </div>
      </div>

      <div class="item">
        <div class="DataContent">
          <h3>Tipo de obra</h3>
          <canvas id="grafico-TipoDeObra" height="200"></canvas>
        </div>
      </div>

      <div class="item">
        <div class="DataContent">
          <h3>Obras por responsáveis</h3>
          <canvas id="grafico-ObrasPorResponsaveis" height="200"></canvas>
        </div>
      </div>

      <div class="item">
        <div class="DataContent">
          <h3>UF</h3>
          <canvas id="grafico-UF" height="300"></canvas>
        </div>
      </div>

      <div class="item" *ngIf="moduleID === 234">
        <div class="DataContent">
          <h3>Padrão da obra</h3>
          <canvas id="grafico-PadraoDaObra" height="200"></canvas>
        </div>
      </div>

      <div class="item">
        <div class="DataContent">
          <h3>Status de negociações</h3>
          <canvas id="grafico-StatusNegociacoes" height="200"></canvas>
        </div>
      </div>

      <div class="item item-full">
        <div class="DataContent">
          <h3>Fase da obra</h3>
          <canvas id="grafico-FaseDaObra" height="120"></canvas>
        </div>
      </div>
    </div>
  </div>
</section>